import React from 'react';
import './ProfileBadge.css';
import ProfileImage from './ProfileImage';

// Compact horizontal badge: circular profile image on the left, nickname
// on the right. Sits at the top-left of the game screens. `src` (saved
// base64) wins over `index`.
export default function ProfileBadge({ index, src, nickname, size = 60, nameSize = 22 }) {
  return (
    <div className="profile-badge">
      <ProfileImage
        index={index}
        src={src}
        className="profile-badge-img"
        style={{ width: size, height: size }}
        alt={nickname || 'profile'}
      />
      <div className="profile-badge-name" style={{ fontSize: nameSize }}>
        {nickname || ''}
      </div>
    </div>
  );
}
